module.exports = __webpack_public_path__ + "static/searchinput-irrelevant-info-do-f274f3362a0b2c362b5614618fbd985f.png";